import { css, styled } from '@mui/material';

import PageHeaderSkeleton from '../PageHeaderSkeleton/PageHeaderSkeleton';
import Skeleton from '../Skeleton/Skeleton';
import { createPageSkeletonClasses } from './theme';

import type { CreatePageSkeletonOwnerState, CreatePageSkeletonProps } from './types';

export default function CreatePageSkeleton(props: CreatePageSkeletonProps) {
  const { formContentHeight = 600, pageHeaderProps, ...others } = props;

  const ownerState: CreatePageSkeletonOwnerState = {
    ...props,
    formContentHeight,
  };

  return (
    <CreatePageSkeletonRoot {...others} ownerState={ownerState}>
      <CreatePageSkeletonHeader
        showBottomDivider
        breadcrumbsCount={3}
        {...pageHeaderProps}
        ownerState={ownerState}
      />
      <CreatePageSkeletonContent ownerState={ownerState}>
        <CreatePageSkeletonFormArea ownerState={ownerState}>
          <Skeleton shape="rectangle" />
        </CreatePageSkeletonFormArea>
      </CreatePageSkeletonContent>
    </CreatePageSkeletonRoot>
  );
}

const CreatePageSkeletonRoot = styled('div', {
  target: createPageSkeletonClasses.root,
})<{ ownerState: CreatePageSkeletonOwnerState }>(
  () => css`
    width: 100%;
  `,
);

const CreatePageSkeletonHeader = styled(PageHeaderSkeleton, {
  target: createPageSkeletonClasses.header,
})<{ ownerState: CreatePageSkeletonOwnerState }>(
  () => css`
    margin: 16px 32px;
  `,
);

const CreatePageSkeletonContent = styled('div', {
  target: createPageSkeletonClasses.content,
})<{ ownerState: CreatePageSkeletonOwnerState }>(
  () => css`
    display: flex;
    flex-direction: column;
    gap: 32px;
    padding: 16px 32px 32px 32px;
  `,
);

const CreatePageSkeletonFormArea = styled('div', {
  target: createPageSkeletonClasses.formArea,
})<{ ownerState: CreatePageSkeletonOwnerState }>(
  ({ ownerState }) => css`
    .MuiSkeleton-root {
      width: 100%;
      height: ${ownerState.formContentHeight}px;
    }
  `,
);
